<template>
    <div class="card">
        <div class="card-header">
            <div class="card-title">
                <span class="font-weight-bold" v-if="active == 1">Xem phiếu đăng ký học tập</span>
                <span class="font-weight-bold" v-if="active == 2">Hoàn tất phiếu đăng ký học tập</span>
                <span class="font-weight-bold" v-if="active == 3">Gửi phiếu đăng ký học tập</span>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <el-steps :active="active" align-center>
                        <el-step title="Tạo phiếu đăng ký học tập"></el-step>
                        <el-step title="Hoàn tất phiếu đăng ký học tập"></el-step>
                        <el-step title="Gửi phiếu đăng ký học tập"></el-step>
                    </el-steps>
                </div>
            </div>
            <div class="mt-6">
                <RegisterStudyFormNewVersion
                    ref="formRef"
                    :errorsForm="errorsForm"
                    :is_show="true"
                    v-if="active === 1"
                    :contract_prop="contract"
                    @dataContract="dataContract"
                ></RegisterStudyFormNewVersion>
                <CompletedStudyFormNewVersion :contract="contract" :policy="policy" v-if="active === 2"></CompletedStudyFormNewVersion>
                <CustomerConfirmFormNewVersion :contract="contract" v-if="active === 3" :url_copy="url_copy"
                                     :url_confirm_contract="url_confirm_contract"></CustomerConfirmFormNewVersion>
            </div>
        </div>
        <div class="card-header d-flex justify-content-end">
            <button class="btn btn-default mr-2" v-if="active > 1" @click="back">Quay lại</button>
            <button class="btn btn-success" v-if="active === 1" :disabled="is_loading_submit" @click="createStudy"><i
                v-if="is_loading_submit" class="el-icon-loading"></i>Xem tiếp
            </button>
            <button class="btn btn-success" v-if="active === 2" :disabled="is_loading_submit" @click="completedStudy"><i
                v-if="is_loading_submit" class="el-icon-loading"></i>Xem tiếp
            </button>
            <button class="btn btn-success" v-if="active === 3" :disabled="is_loading_submit" @click="confirmCustomer">
                <i
                    v-if="is_loading_submit" class="el-icon-loading"></i>Xác
                nhận
            </button>
        </div>
    </div>
</template>
<script>
import {mapGetters} from "vuex";

import Multiselect from "vue-multiselect";
import lodash from 'lodash-es';
import deepdash from 'deepdash-es';
import RegisterStudyFormNewVersion from "@/views/pages/customer/components/RegisterStudyFormNewVersion";
import CompletedStudyFormNewVersion from "@/views/pages/customer/components/CompletedStudyFormNewVersion";
import CustomerConfirmFormNewVersion from "@/views/pages/customer/components/CustomerConfirmFormNewVersion";
import {
    CONTRACT_ONLINE_GET_BY_ID, CONTRACT_ONLINE_GET_SHORT_LINK, UPDATE_PAYMENT_OPTION_BY_CONTRACT
} from "@/core/services/store/contract/contractOnline.module";
import {CUSTOMER_UPDATE_LEVEL} from "@/core/services/store/customer/customer.module";
import {LEVEL_3A} from "@/core/config/customer/customerOption";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {CAMBRIDGE, ECOACH, IELTS, TOEIC, ANU, IELTS_CAMBRIDGE, MENTER_ENGLISH_MASTERY} from "../../../core/config/center/centerOption";
import { CONTRACT_ONLINE_V2_GET_BY_ID } from "../../../core/services/store/contract/contractOnline.module";

const _ = deepdash(lodash);
export default {
    name: "ShowContractEdutalkNewVersion",
    props: {},
    components: {
        CustomerConfirmFormNewVersion,
        CompletedStudyFormNewVersion,
        RegisterStudyFormNewVersion,
        Multiselect
    },
    data() {
        return {
            errorsForm: {},
            active: 1,
            is_loading_submit: false,
            contract: {
                student_link :'',
                id: '',
                uuid: '',
                uuid_secret: '',
                is_confirm: 0,
                tuition_payment_id: '',
                is_older: true,
                name: '',
                phone: '',
                phone_other: '',
                email: '',
                birthday: '',
                center_id: '',
                branch_id: '',
                customer_id: this.$route.query.customer_id,
                total: '',
                total_need: '',
                total_promotions: '',
                courses: [
                    {
                        id: "",
                        name: "",
                        fee: 0
                    }
                ],
                list_promotions: [],
                parent: {
                    type: 'bo',
                    other_value: '',
                    name: '',
                    phone: '',
                    phone_other: '',
                }
            },
            url_copy: '',
            url_confirm_contract: '',
            policy: {}
        }
    },
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            {title: "Danh sách hợp đồng tư vấn"},
            {title: "Xem phiếu đăng ký học tập", icon: 'far fa-user'}
        ]);
        let id = this.$route.params.contract_id;
        this.getContractById(id);
    },
    methods: {
        dataContract(data) {
            this.contract = data;
        },
        hasPaymentMethod() {
            const ids = this.contract?.method_payment_id;
            if (Array.isArray(ids)) {
                return ids.map(Number).some((id) => id > 0);
            }
            return Boolean(ids);
        },
        async createStudy() {
            const form = this.$refs.formRef;
            if (form && typeof form.prepareContractPayload === "function") {
                this.contract = form.prepareContractPayload();
            }

            // Chưa đóng tiền: giữ logic cũ (chỉ xem tiếp).
            // Đã đóng tiền: cập nhật payment_option nếu đã chọn cách thanh toán.
            if (Number(this.contract.total_paid) <= 0 || !this.hasPaymentMethod()) {
                this.next();
                return;
            }

            this.is_loading_submit = true;
            try {
                const data = await this.$store.dispatch(UPDATE_PAYMENT_OPTION_BY_CONTRACT, {
                    contract_id: this.contract.id,
                    branch_id: this.contract.branch_id,
                    method_payment_id: this.contract.method_payment_id,
                    payment_option: this.contract.payment_option,
                    payment_amount: this.contract.payment_amount,
                    installments_number: this.contract.installments_number,
                });
                this.contract.payment_options = data.data;
                this.$message.success(data.message || "Đã lưu thông tin thanh toán");
                this.next();
                this.changeLink();
            } catch (e) {
                this.$message.error({
                    message: e?.data?.message || "Lưu thông tin thanh toán thất bại",
                    duration: 10000,
                    showClose: true,
                });
            } finally {
                this.is_loading_submit = false;
            }
        },
        changeLink() { 
            const path_url_confirm_contract = `/hd/${this.contract.code}`;
            let domain = '';
            switch (this.contract.center_id) {
                case ECOACH:
                    domain = `${process.env.VUE_APP_BASE_URL_CONTRACT_CLASSUP}`;
                    break;
                case IELTS:
                case CAMBRIDGE:
                case MENTER_ENGLISH_MASTERY:
                    domain = `${process.env.VUE_APP_BASE_URL_CONTRACT_IELTSMENTOR}`;
                    break;  
                default: domain = '';
            }
            this.url_copy = domain + path_url_confirm_contract;
            this.url_confirm_contract = this.getShortLinkConfirm(this.url_copy);
        },
        getShortLinkUrlCopy(url) {
            this.$store.dispatch(CONTRACT_ONLINE_GET_SHORT_LINK, {
                url: url,
                center_id: this.contract.center_id
            }).then((data) => {
                this.url_copy = data.data;
            });
        },
        getShortLinkConfirm(url) {
            this.$store.dispatch(CONTRACT_ONLINE_GET_SHORT_LINK, {
                url: url,
                center_id: this.contract.center_id
            }).then((data) => {
                this.url_confirm_contract = data.data;
            });
        },
        completedStudy() {
            this.next();
        },
        confirmCustomer() {
            this.$store.dispatch(CUSTOMER_UPDATE_LEVEL, {
                customer_id: this.contract.customer_id,
                level: LEVEL_3A
            }).then(() => {
                this.$message.success('Xác nhận thành công');
                this.$router.push({
                    name: "contract-index"
                })
            }).catch((e) => {
                this.$message.error(e.data.message);
            })
        },
        next() {
            this.changeLink();
            if (this.active++ > 2) this.active = 1;
        },
        back() {
            if (this.active-- === 0) this.active = 1;
            if (this.contract.id) {
                this.getContractById(this.contract.id);
            }
        },
        getContractById(id) {
            this.$store.dispatch(CONTRACT_ONLINE_V2_GET_BY_ID, id).then((data) => {
                this.contract = this.formatContractData(data.data);
                this.policy = data.data.policy ?? null;
                this.changeLink();
                this.$nextTick(() => {
                    if (this.$refs.formRef && this.contract.province_id) {
                        this.$refs.formRef.getDistricts();
                    }
                });
            });
        },
        formatContractData(apiData) {
            let formatted = { ...apiData };
            formatted.cccd = apiData?.cccd;
            formatted.place_of_residence = apiData.place_of_residence || apiData.address;
            formatted.sub_district = apiData.sub_district || apiData.address;
            
            if (formatted.payer) {
                formatted.payer.installment_fee = formatted.payer.installment_fee ?? formatted.payer.prepayment ?? null;
                formatted.payer.consultationTimeSlot = formatted.payer.consultationTimeSlot ?? formatted.payer.consulting_time ?? null;
                
                let proofs = formatted.payer.financial_proof_urls || [];
                formatted.payer.financial_proof_urls = [
                    proofs[0] || '',
                    proofs[1] || '',
                    proofs[2] || ''
                ];
            }
            if (!formatted.parent) {
                formatted.parent = {
                    type: 'bo', name: '', phone: '', phone_other: '', 
                    birthday: '', place_of_residence: '', cccd: '', 
                    cccd_issued_date: '', cccd_issued_place: '', 
                    cccd_front_url: '', cccd_back_url: ''
                };
            }
            if(formatted.list_promotions && formatted.list_promotions.length) {
                formatted.gift_id = formatted.list_promotions.filter(p => p.type === 1).map(p => p.id);
            } else {
                formatted.gift_id = [];
            }
            return formatted;
        },
    },
    computed: {
        ...mapGetters(['currentUser'])
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.withdraw-course {
    position: absolute;
    right: 20px;
    top: 37px;
}
</style>
